import { HttpErrorResponse } from '@angular/common/http';
import { SyncMetadata } from '@core/db/app-db';

export function createLocalId(): number {
  const random = Math.floor(Math.random() * 1000);
  return (Date.now() * -1) - random;
}

export function createClientOperationId(): string {
  return crypto.randomUUID();
}

export function resolveUpdatedAt(value: unknown): string {
  if (typeof value === 'string' && value.trim()) {
    return value;
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  return new Date().toISOString();
}

export function withSyncMetadata<T>(
  record: T,
  overrides: Partial<SyncMetadata> = {},
): T & SyncMetadata {
  const source = (record ?? {}) as Record<string, unknown>;

  return {
    ...record,
    synchronized: overrides.synchronized ?? true,
    updatedAt: overrides.updatedAt ?? resolveUpdatedAt(
      source['updatedAt'] ?? source['updated_at'],
    ),
    clientOperationId:
      overrides.clientOperationId ??
      (typeof source['clientOperationId'] === 'string'
        ? String(source['clientOperationId'])
        : null),
  };
}

export function shouldUseOfflineFallback(error: unknown): boolean {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    return true;
  }

  if (error instanceof HttpErrorResponse) {
    return error.status === 0;
  }

  const normalizedError = error as {
    code?: unknown;
    error?: { code?: unknown };
  } | null;
  if (
    normalizedError?.code === 0 ||
    normalizedError?.error?.code === 'NETWORK_ERROR'
  ) {
    return true;
  }

  return error instanceof TypeError;
}
